



























































import { Vue, Component } from 'vue-property-decorator';
import T from '../../lang';

@Component
export default class UserPasswordEdit extends Vue {
  T = T;
  oldPassword = '';
  newPassword = '';
  newPassword2 = '';

  get passwordMismatch(): boolean {
    return this.newPassword != this.newPassword2;
  }

  get invalidPasswordClass(): string {
    return this.passwordMismatch ? 'invalid-input' : '';
  }

  get submitDisabled(): boolean {
    return (
      this.passwordMismatch ||
      this.newPassword.length === 0 ||
      this.newPassword2.length === 0 ||
      this.oldPassword.length === 0
    );
  }

  onUpdatePassword(): void {
    if (this.passwordMismatch) {
      return;
    }
    this.$emit('update-password', {
      oldPassword: this.oldPassword,
      newPassword: this.newPassword,
    });
  }
}
